<template>
    <div id="page-container">
    <!-- Main Container -->
        <main id="main-container">
            <router-view />
        </main>
   </div> 

</template>

<script>
import {onMounted} from 'vue'
import { loadScript } from 'vue-plugin-load-script'
export default {
    name:"Auth",
    setup(){
    onMounted(()=>{
        // loadScript("../../js/dashmix.app.min.js")
        localStorage.setItem("dashmixDefaultsSidebarDark", "true");
        localStorage.setItem("dashmixDefaultsPageHeaderDark", "true");
    })
    return{
    // 
    }
    }
}
</script>
